<div class="{{baCheckboxClass}}">
  <label class="checkbox-inline custom-checkbox nowrap">
    <input type="checkbox" [checked]=state
           (change)="onChange($event.target.checked)"
           [disabled]="disabled" [value]="value">
    <span>{{label}}</span>
  </label>
</div>
